"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signOrder = exports.signCustomData = exports.broadcastTransfer = exports.broadcastInvoke = exports.invocationFee = void 0;
var dappErorrs_1 = require("./dappErorrs");
var waitTx_1 = require("./waitTx");
exports.invocationFee = 500000;
var toBase64 = function (bytes) {
    return global.Buffer
        ? global.Buffer.from(bytes).toString('base64')
        : btoa(bytes);
};
var isKeeper = function (signerOrKeeper) { return 'initialPromise' in signerOrKeeper; };
var broadcastInvoke = function (_a, signerOrKeeper, _b, _fetch) {
    var nodeApi = _a.nodeApi;
    var dApp = _b.dApp, func = _b.func, args = _b.args, fee = _b.fee, feeAssetId = _b.feeAssetId, payment = _b.payment;
    if (_fetch === void 0) { _fetch = fetch; }
    var params = {
        dApp: dApp,
        call: { function: func, args: args },
        payment: payment,
    };
    var bk = function () {
        var _a, _b;
        if (isKeeper(signerOrKeeper)) {
            return signerOrKeeper.signAndPublishTransaction({
                type: 16,
                data: __assign(__assign({}, params), { fee: {
                        coins: fee,
                        assetId: feeAssetId || 'WAVES',
                    } })
            }).then(extractId);
        }
        else {
            console.log('invoke via signer-metamask', __assign(__assign({}, params), { fee: fee, feeAssetId: feeAssetId }));
            //claimAllRewardsAndAllEbAvailable2
            //claimProtocolProfitFrom
            var hack = !((_b = (_a = params === null || params === void 0 ? void 0 : params.payment) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.assetId);
            return signerOrKeeper.invoke(__assign(__assign(__assign({}, params), (hack ? { assetId: 'DSbbhLsSTeDg5Lsiufk2Aneh3DjVqJuPr2M9uU1gwy5p' } : {})), { 
                //call: { ...params.call, args: [] },
                fee: fee, feeAssetId: feeAssetId })).broadcast().then(extractId);
        }
    };
    return bk().then(function (txId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, waitTx_1.waitTx)({
                        txId: txId,
                        nodeApi: nodeApi,
                        _fetch: _fetch
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, txId];
            }
        });
    }); })
        .catch(function (e) { return (0, dappErorrs_1.dappErrorHandler)(e, isKeeper(signerOrKeeper)); });
};
exports.broadcastInvoke = broadcastInvoke;
var broadcastTransfer = function (_a, signerOrKeeper, _b, _fetch) {
    var nodeApi = _a.nodeApi;
    var recipient = _b.recipient, assetId = _b.assetId, amount = _b.amount, fee = _b.fee, feeAssetId = _b.feeAssetId;
    if (_fetch === void 0) { _fetch = fetch; }
    return (isKeeper(signerOrKeeper)
        ? signerOrKeeper.signAndPublishTransaction({
            type: 4,
            data: {
                recipient: recipient,
                amount: {
                    coins: amount,
                    assetId: assetId,
                },
                fee: {
                    coins: fee,
                    assetId: feeAssetId || 'WAVES',
                },
            }
        }).then(extractId)
        : signerOrKeeper.transfer({
            recipient: recipient,
            amount: amount,
            assetId: assetId,
            fee: fee,
            feeAssetId: feeAssetId,
        }).broadcast()
            .then(extractId)).then(function (txId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, waitTx_1.waitTx)({
                        txId: txId,
                        nodeApi: nodeApi,
                        _fetch: _fetch
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, txId];
            }
        });
    }); })
        .catch(dappErorrs_1.transferErrorHandler);
};
exports.broadcastTransfer = broadcastTransfer;
var signCustomData = function (signerOrKeeper, bytes) {
    return isKeeper(signerOrKeeper)
        ? signerOrKeeper.signCustomData({
            version: 1,
            binary: 'base64:' + toBase64(bytes),
        }).then(function (x) { return x.signature; })
        : signerOrKeeper.signMessage(bytes);
};
exports.signCustomData = signCustomData;
var extractId = function (x) {
    var _a;
    return typeof x === 'string'
        ? JSON.parse(x).id
        : ((_a = x[0]) === null || _a === void 0 ? void 0 : _a.id) || (x === null || x === void 0 ? void 0 : x.id);
};
var signOrder = function (signerOrKeeper) { return function (orderParams) {
    if (isKeeper(signerOrKeeper))
        throw new Error('signOrder is not supported for Keeper');
    var provider = signerOrKeeper.currentProvider;
    if (!provider.signOrder)
        throw new Error('signOrder is not supported for this signer provider');
    return provider.signOrder(orderParams);
}; };
exports.signOrder = signOrder;
//# sourceMappingURL=generic.js.map